// extracted by mini-css-extract-plugin
module.exports = {"infographic_box":"MtY9I","articleshowv2":"nizI7","infographic_inner":"rkwec"};